import { Page } from "@/models/page-models/Page";

export const SalesForecastMaster: Page = {
  "path": "sales-forecast",
  "name": "Forecast",
  "props": {
    "data": {
      "title": "Forecast",
      "printable": "FALSE",
      "url": "sales-forecast",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.forecastYear",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "loadDraftSalesForecastStatusData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Draft",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.draftForecastStatusData"
                      },
                      "name": "loadDraftSalesForecastStatusData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "loadSubmittedSalesForecastStatusData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Submitted",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.submittedForecastStatusData"
                      },
                      "name": "loadSubmittedSalesForecastStatusData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "loadApprovedSalesForecastStatusData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Approved",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.approvedForecastStatusData"
                      },
                      "name": "loadApprovedSalesForecastStatusData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "loadCancelledSalesForecastStatusData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Cancelled",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.cancelledForecastStatusData"
                      },
                      "name": "loadCancelledSalesForecastStatusData"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "disabled": "fn(NOT,{{formData.forecastYear}})",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Load Customer Forecast",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToSalesForecast",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/customer-sales-forecast",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{formData.customer}}\",\"year\":\"{{formData.forecastYear}}\",\"displaySAR\":\"false\"}"
                      },
                      "name": "redirectToSalesForecast"
                    }
                  ],
                  "disabled": "fn(NOT,{{formData.customer}})",
                  "color": "secondary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },  
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Draft",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.draftForecastStatusData.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Draft Forecasts",
                      "disabled": "FALSE",
                      "items": "fetchedData.draftForecastStatusData.data",
                      "showIf": "{{fetchedData.draftForecastStatusData.data}}",
                      "headers": [
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "url",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "url": "/customer-sales-forecast?customer={{__item.customer._id}}&year={{fetchedData.forecastForm.year}}&displaySAR=false"
                        },
                        {
                          "value": "customer.status",
                          "text": "Customer Type"
                        },
                        {
                          "value": "salesGroup.name",
                          "text": "Group"
                        },
                        {
                          "value": "salesman.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "total",
                          "text": "Forecast Value",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.total}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "forecastStatus",
                          "text": "Forecast Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.submittedForecastStatusData.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Submitted Forecasts",
                      "disabled": "FALSE",
                      "items": "fetchedData.submittedForecastStatusData.data",
                      "showIf": "{{fetchedData.submittedForecastStatusData.data}}",
                      "headers": [
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "url",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "url": "/customer-sales-forecast?customer={{__item.customer._id}}&year={{fetchedData.forecastForm.year}}&displaySAR=false"
                        },
                        {
                          "value": "customer.status",
                          "text": "Customer Type"
                        },
                        {
                          "value": "salesGroup.name",
                          "text": "Group"
                        },
                        {
                          "value": "salesman.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "total",
                          "text": "Forecast Value",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.total}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "forecastStatus",
                          "text": "Forecast Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Approved",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.approvedForecastStatusData.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Approved Forecasts",
                      "disabled": "FALSE",
                      "items": "fetchedData.approvedForecastStatusData.data",
                      "showIf": "{{fetchedData.approvedForecastStatusData.data}}",
                      "headers": [
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "url",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "url": "/customer-sales-forecast?customer={{__item.customer._id}}&year={{fetchedData.forecastForm.year}}&displaySAR=true"
                        },
                        {
                          "value": "customer.status",
                          "text": "Customer Type"
                        },
                        {
                          "value": "salesGroup.name",
                          "text": "Group"
                        },
                        {
                          "value": "salesman.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "total",
                          "text": "Forecast Value",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.total}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "forecastStatus",
                          "text": "Forecast Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false
                    }
                  ]
                }
              ]
            }
            ,
            {
              "tabName": "Cancelled",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.cancelledForecastStatusData.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Approved Forecasts",
                      "disabled": "FALSE",
                      "items": "fetchedData.cancelledForecastStatusData.data",
                      "showIf": "{{fetchedData.cancelledForecastStatusData.data}}",
                      "headers": [
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "url",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "url": "/customer-sales-forecast?customer={{__item.customer._id}}&year={{fetchedData.forecastForm.year}}&displaySAR=true"
                        },
                        {
                          "value": "customer.status",
                          "text": "Customer Type"
                        },
                        {
                          "value": "salesGroup.name",
                          "text": "Group"
                        },
                        {
                          "value": "salesman.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "total",
                          "text": "Forecast Value",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.total}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "forecastStatus",
                          "text": "Forecast Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copySalesforecastYear",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getSalesforecastYear",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copySalesforecastYear"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "loadDraftSalesForecastStatusData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Draft",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.draftForecastStatusData"
        },
        "name": "loadDraftSalesForecastStatusData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "loadSubmittedSalesForecastStatusData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Submitted",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.submittedForecastStatusData"
        },
        "name": "loadSubmittedSalesForecastStatusData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "loadApprovedSalesForecastStatusData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Approved",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.approvedForecastStatusData"
        },
        "name": "loadApprovedSalesForecastStatusData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "loadCancelledSalesForecastStatusData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/forecast-status/generate?year={{formData.forecastYear}}&status=Cancelled",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.cancelledForecastStatusData"
        },
        "name": "loadCancelledSalesForecastStatusData"
      }
    ],
    "functions": [
      {
        "name": "getSalesforecastYear",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "forecastYear": "{{FORECAST_YEAR}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 100
}